import React from 'react'
import PropTypes from 'prop-types'
import { APIProvider, InfoWindow, Map, Marker } from '@vis.gl/react-google-maps'
import s from './GoogleMap.module.css'

function GoogleMap({
  latitude = '',
  longitude = '',
  info = '',
  markerLink = '',
}) {
  const lat = parseFloat(latitude)
  const lng = parseFloat(longitude)
  const markerLocation = { lat, lng }

  return (
    <div className={s.container}>
      <APIProvider apiKey="AIzaSyDm13VXT0juDx965VSRVuB1BGEapB2VSrE">
        <Map
          // mapId="56ddbf3b0605d21"
          style={{ width: '100vw', height: '100vh' }}
          defaultCenter={markerLocation}
          defaultZoom={16}
          gestureHandling={'greedy'}
          disableDefaultUI={true}
          styles={[
            {
              featureType: 'administrative',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#444444' }],
            },
            {
              featureType: 'landscape',
              elementType: 'all',
              stylers: [{ color: '#f2f2f2' }],
            },
            {
              featureType: 'poi',
              elementType: 'all',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'poi',
              elementType: 'labels.text',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road',
              elementType: 'all',
              stylers: [{ saturation: -100 }, { lightness: 45 }],
            },
            {
              featureType: 'road.highway',
              elementType: 'all',
              stylers: [{ visibility: 'simplified' }],
            },
            {
              featureType: 'road.arterial',
              elementType: 'labels.icon',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'transit',
              elementType: 'all',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'water',
              elementType: 'all',
              stylers: [{ color: '#dbdbdb' }, { visibility: 'on' }],
            },
          ]}
        >
          <Marker
            position={markerLocation}
            icon="/img/svg/circle.svg"
            onClick={() => {
              window.location =
                markerLink ||
                `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: info }} />
          </Marker>
          {info && (
            <InfoWindow position={markerLocation} headerDisabled={true}>
              <div dangerouslySetInnerHTML={{ __html: info }} />
            </InfoWindow>
          )}
        </Map>
      </APIProvider>
    </div>
  )
}

GoogleMap.propTypes = {
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  info: PropTypes.string,
  markerLink: PropTypes.string,
}

export default GoogleMap
